import { useState } from 'react';
import {
  Button, Badge, Field, Input, Select, SearchInput,
  Alert, Modal, Stepper, Spinner, Skeleton, EmptyState, useToast, Container,
} from '../../components/ui';
import SeccionGuia from './SeccionGuia';

export default function Componentes() {
  const [modalAbierto, setModalAbierto] = useState(false);
  const { notify } = useToast();

  return (
    <Container>
      <h1>Guía de componentes</h1>
      <p style={{ color: 'var(--c-text-muted)', maxWidth: '60ch' }}>
        Componentes reutilizables del sistema de diseño. Mantienen la consistencia de UI en toda la app.
      </p>

      <div style={{ display: 'grid', gap: 'var(--space-5)' }}>
        <SeccionGuia titulo="Botones">
          <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
            <Button>Primario</Button>
            <Button variant="accent">Acento</Button>
            <Button variant="secondary">Secundario</Button>
            <Button variant="ghost">Fantasma</Button>
            <Button variant="danger">Peligro</Button>
            <Button variant="dangerSoft">Peligro suave</Button>
            <Button disabled>Deshabilitado</Button>
          </div>
        </SeccionGuia>

        <SeccionGuia titulo="Estados / badges">
          <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
            <Badge tone="success" dot>Confirmado</Badge>
            <Badge tone="warning" dot>Pendiente</Badge>
            <Badge tone="danger" dot>Cancelado</Badge>
            <Badge tone="info">Cobertura</Badge>
            <Badge tone="accent">Disponible</Badge>
          </div>
        </SeccionGuia>

        <SeccionGuia titulo="Campos de formulario">
          <Field label="Texto" htmlFor="t1" hint="Un campo de ejemplo">
            <Input id="t1" placeholder="Escribí algo…" />
          </Field>
          <Field label="Selección" htmlFor="s1">
            <Select id="s1"><option>Opción A</option><option>Opción B</option></Select>
          </Field>
          <Field label="Con error" htmlFor="e1" error="Este campo es obligatorio">
            <Input id="e1" error defaultValue="valor inválido" />
          </Field>
          <Field label="Búsqueda" htmlFor="q1">
            <SearchInput id="q1" placeholder="Buscar…" />
          </Field>
        </SeccionGuia>

        <SeccionGuia titulo="Feedback">
          <div style={{ display: 'grid', gap: 12 }}>
            <Alert tone="success" title="¡Listo!">Operación realizada con éxito.</Alert>
            <Alert tone="danger" title="Error">No se pudo completar la acción.</Alert>
            <Alert tone="warning">Revisá los datos antes de continuar.</Alert>
            <Alert tone="info">Información útil para el usuario.</Alert>
            <div>
              <Button variant="secondary" onClick={() => notify('Turno reservado con éxito', { title: '¡Listo!' })}>
                Mostrar toast
              </Button>
            </div>
          </div>
        </SeccionGuia>

        <SeccionGuia titulo="Carga">
          <Spinner label="Cargando turnos…" />
          <div style={{ maxWidth: 320, marginTop: 16, display: 'grid', gap: 10 }}>
            <Skeleton width="60%" />
            <Skeleton width="80%" />
            <Skeleton width="40%" />
          </div>
        </SeccionGuia>

        <SeccionGuia titulo="Wizard (stepper)">
          <Stepper pasos={['Tipo de búsqueda', 'Fecha', 'Turno']} actual={1} />
        </SeccionGuia>

        <SeccionGuia titulo="Estado vacío">
          <EmptyState title="No tenés turnos próximos." action={<Button to="/buscar" size="sm">Reservar un turno</Button>} />
        </SeccionGuia>

        <SeccionGuia titulo="Modal">
          <Button onClick={() => setModalAbierto(true)}>Abrir modal</Button>
          <Modal
            open={modalAbierto}
            onClose={() => setModalAbierto(false)}
            title="Confirmar acción"
            description="Este es un diálogo de confirmación de ejemplo."
            actions={
              <>
                <Button variant="secondary" onClick={() => setModalAbierto(false)}>Cancelar</Button>
                <Button variant="accent" onClick={() => setModalAbierto(false)}>Confirmar</Button>
              </>
            }
          />
        </SeccionGuia>
      </div>
    </Container>
  );
}